<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11EOmNI/tc-custom/9781610589024.jpg?1725275820906" alt="This image is the cover for the book Merrill's Marauders"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Merrill's Marauders
      </h1>
      <p class="bookDescription body article font2">
        <b>A critically acclaimed historian reveals the heroism and perseverance of a US Army special ops unit during one of the most overlooked campaigns of WWII.</b><br/><br/>In August of 1943, a call went out for American soldiers willing to embark on a “hazardous and dangerous mission” behind enemy lines in Burma. The war department wanted 3,000 volunteers, and it didn’t care who they were; they would be expendable, with an expected casualty rate of eighty-five percent. The men who took up the challenge were, in the words of one, “bums and cast-offs” with rap sheets and reputations for trouble. One war reporter described them as “Dead End Kids,” but by the end of their five-month mission, those that remained had become the legendary “Merrill’s Marauders.”<br/><br/>From award-winning historian Gavin Mortimer, <i>Merrill’s Marauders</i> is the story of the American World War II special forces unit originally codenamed “Galahad,” which, in 1944, fought its way through 700 miles of snake-infested Burmese jungle—what Winston Churchill described as “the most forbidding fighting country imaginable.” Though their mission to disrupt Japanese supply lines and communications was ultimately successful, paving the way for the Allied conquest of Burma, the Marauders paid a terrible price for their victory. By the time they captured the crucial airfield of Myitkyina in May 1944, only 200 of the original 3,000 men remained; the rest were dead, wounded, or riddled with disease. This is the definitive nonfiction narrative of arguably the most extraordinary, but also unsung, American special forces unit in World War II.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gavin Mortimer
      </h2>
      
      <p class="authorDescription body article">Gavin Mortimer is a best-selling author and an award-winning historian whose versatile narrative nonfiction books have been published in the United States and Great Britain.He is the author of Merrill's Marauders (Zenith Press, 2013), which profiles the American jungle fighters who fought a brutal campaign against the Japanese in Burma in 1944 and was seen on the CBS network during its coverage of Veterans Day 2013.Mortimer's other recent title is The History of the Special Boat Squadron in World War 2, an Amazon bestseller that was featured prominently in the Daily Telegraph and the Daily Mirror, the latter praising it as a "remarkable" account of the wartime SBS.Mortimer is also the author of The First Eagles, to be released in the summer of 2014, which is a compelling account of the American pilots who flew with the Royal Air Force in World War I.www.gavinmortimer.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Zenith Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?11125b6b